import { createContext, useContext, useState, useEffect } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext({});

const DEFAULTS = {
  platform_name: "Aumenta Ya",
  logo_text: "Aumenta Ya",
  whatsapp: "+595983265235",
  instagram: "@aumentaya",
  tiktok: "@aumentaya",
  hero_title: "Impulsá tu Instagram de forma rápida y sencilla.",
  hero_subtitle: "Elegí tu servicio, ingresá tu usuario y realizá tu pedido en pocos pasos.",
  brand_slogan: "Impulsá tu Instagram. Crecé con Aumenta Ya.",
  services_title: "Nuestros servicios",
  services_subtitle: "Elegí el impulso que tu perfil necesita. Precios claros, entrega segura.",
  howto_title: "Cómo funciona",
  howto_subtitle: "En 4 simples pasos, sin complicaciones.",
  faq_title: "Preguntas frecuentes",
  cta_title: "¿Listo para crecer?",
  cta_subtitle: "Impulsá tu Instagram hoy mismo. Rápido, seguro y en guaraníes.",
  footer_tagline: "Servicios digitales para impulsar tu presencia online. Rápido, seguro y en guaraníes.",
  refill_url: "https://refil.perfilturbinado.com/",
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULTS);
  useEffect(() => {
    api
      .get("/settings/public")
      .then((r) => setSettings({ ...DEFAULTS, ...r.data }))
      .catch(() => {});
  }, []);
  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext);

export const waLink = (phone, message) => {
  const clean = (phone || "").replace(/[^0-9]/g, "");
  return `https://wa.me/${clean}?text=${encodeURIComponent(message || "")}`;
};
